import { initializeTrustedTypes } from './trustedTypes';

initializeTrustedTypes();
